module.exports = __webpack_public_path__ + "media/images/logo-business-black-4e87c1e6.png";